import {nextTick, ref, watch} from "vue";

export function useCodeBoxShared(verificationCode) {
  const container = ref(null);
  const codeBoxContent = ref(["", "", "", "", "", ""]);
  const isApplyingParentCode = ref(false);

  function getInputs() {
    return container.value?.querySelectorAll(".box") || [];
  }

  function getName(index) {
    return `code-${index + 1}`;
  }

  function getId(index) {
    return `code-${index + 1}`;
  }

  function getAriaLabel(index) {
    return `Digit ${index + 1} of 6`;
  }

  function getJoinedCode() {
    return codeBoxContent.value.join("");
  }

  function clearBoxes() {
    for (let index = 0; index < codeBoxContent.value.length; index += 1) {
      codeBoxContent.value[index] = "";
    }
  }

  function getDigits(value) {
    return String(value || "").match(/\d/g)?.slice(0, 6) || [];
  }

  function setBoxesFromCode(code) {
    const digits = getDigits(code);
    for (let index = 0; index < 6; index += 1) {
      codeBoxContent.value[index] = digits[index] || "";
    }
  }

  function setVerificationCode(next) {
    if (!verificationCode) return;
    if (isApplyingParentCode.value) return;
    if (verificationCode.value === next) return;
    verificationCode.value = next;
  }

  function focusInput(index) {
    const input = getInputs()[index];
    if (!input) return;
    input.focus();
  }

  function focusNextInput(index) {
    const nextInput = getInputs()[index + 1];
    if (!nextInput) return;
    nextInput.focus();
  }

  function focusPrevInput(index) {
    const prevInput = getInputs()[index - 1];
    if (!prevInput) return;
    prevInput.focus();
  }

  async function autoFocusFirstInput() {
    await nextTick();
    const firstInput = getInputs()[0];
    if (firstInput) firstInput.focus();
  }

  async function applyParentCode(next) {
    const code = String(next || "").trim();
    if (code === getJoinedCode()) return;
    isApplyingParentCode.value = true;
    if (!code) {
      clearBoxes();
      await nextTick();
      focusInput(0);
      isApplyingParentCode.value = false;
      return;
    }
    setBoxesFromCode(code);
    isApplyingParentCode.value = false;
  }

  watch(() => getJoinedCode(), (next) => setVerificationCode(next));
  watch(() => verificationCode?.value, (next) => applyParentCode(next));

  return {
    container,
    codeBoxContent,
    getInputs,
    getName,
    getId,
    getAriaLabel,
    getJoinedCode,
    clearBoxes,
    getDigits,
    setBoxesFromCode,
    setVerificationCode,
    focusInput,
    focusNextInput,
    focusPrevInput,
    autoFocusFirstInput,
  };
}
